import { useTheme } from '../theme/use-theme';
export var identiconComponentName = 'QuantumIdenticon';
export var IdenticonsCustomProperty;
(function (IdenticonsCustomProperty) {
    IdenticonsCustomProperty["light"] = "--identicons-color-light";
    IdenticonsCustomProperty["base"] = "--identicons-color-base";
    IdenticonsCustomProperty["dark"] = "--identicons-color-dark";
})(IdenticonsCustomProperty || (IdenticonsCustomProperty = {}));
export var getIdenticonsColorMap = function (color, theme) {
    if (color === void 0) { color = 'default'; }
    if (color === 'primary') {
        return theme.palette.identicons.primary;
    }
    return theme.palette.identicons.default;
};
export var getIdenticonsVariableOverrides = function (color, theme) {
    var _a;
    if (color === void 0) { color = 'default'; }
    var map = getIdenticonsColorMap(color, theme);
    return _a = {},
        _a[IdenticonsCustomProperty.light] = map.light,
        _a[IdenticonsCustomProperty.base] = map.base,
        _a[IdenticonsCustomProperty.dark] = map.dark,
        _a;
};
export var useColorMap = function (_a) {
    var color = _a.color;
    var theme = useTheme();
    return getIdenticonsColorMap(color, theme);
};
